import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ApiConfigService {
  private readonly baseUrl = environment.apiUrl;

  // Auth endpoints
  get authUrl(): string {
    return `${this.baseUrl}/api/auth`;
  }

  // Harmonization endpoints
  get harmonizationBaseUrl(): string {
    return `${this.baseUrl}/api/harmonization`;
  }

  get harmonizationBatchesUrl(): string {
    return `${this.harmonizationBaseUrl}/batches`;
  }

  get harmonizationStatusSummaryUrl(): string {
    return `${this.harmonizationBaseUrl}/status-summary`;
  }

  get harmonizationSearchUrl(): string {
    return `${this.harmonizationBaseUrl}/search`;
  }

  get harmonizationDataParsingDefinitionsUrl(): string {
    return `${this.harmonizationBaseUrl}/getdataparsingdefinitions`;
  }

  get harmonizationBulkUrl(): string {
    return `${this.harmonizationBaseUrl}/bulk`;
  }

  // Auth configuration
  get authRedirectUri(): string {
    return environment.auth.redirectUri;
  }
} 